import SgpTable from './table.vue'

SgpTable.install = function (Vue) {
  Vue.component(SgpTable.name, SgpTable)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(SgpTable)
}

export default SgpTable
